module.exports = __webpack_public_path__ + "img/1.1b3b8664.svg";